module.exports = __webpack_public_path__ + "img/2.afde90e9.jpg";